import { useCallback } from 'react';
import { useBlocker } from 'react-router';
export function useNavigateBlocker(shouldBlock) {
  const wrappedBlocker = useCallback(args => {
    if (args.nextLocation.state?.noBlockNavigation) {
      return false;
    }
    return typeof shouldBlock === 'boolean' ? shouldBlock : shouldBlock(args);
  }, [shouldBlock]);
  return useBlocker(wrappedBlocker);
}